export const AuthLoginConstants = {
  AUTH_LOGIN_REQUEST: 'LOGIN_REQUEST',
  AUTH_LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  AUTH_LOGIN_FAIL: 'LOGIN_FAIL',
  AUTH_CLEAR_ERRORS: ' AUTH_CLEAR_ERRORS',
};

export const AUTH_LOGOUT='AUTH_LOGOUT'
export const AUTH_LOGOUT_COMPLETE='AUTH_LOGOUT_COMPLETE'

export const AuthDeleteConstants = {
  AUTH_DELETE_REQUEST: ' AUTH_DELETE_REQUEST',
  AUTH_DELETE_SUCCESS: ' AUTH_DELETE_SUCCESS',
  AUTH_DELETE_FAIL: ' AUTH_DELETE_FAIL'
};

export const AuthUpdateConstants = {
  AUTH_UPDATE_REQUEST: 'LOGIN_UPDATE_REQUEST',
  AUTH_UPDATE_SUCCESS: 'LOGIN_UPDATE_SUCCESS',
  AUTH_UPDATE_FAIL: 'LOGIN_UPDATE_FAIL',
  AUTH_CLEAR_ERRORS: ' AUTH_CLEAR_ERRORS',
};

export const AuthRegisterConstants = {
  AUTH_REGISTER_REQUEST: ' AUTH_REGISTER_REQUEST',
  AUTH_REGISTER_SUCCESS: 'AUTH_REGISTER_SUCCESS',
  AUTH_REGISTER_FAIL: 'AUTH_REGISTER_FAIL',
  AUTH_CLEAR_ERRORS: ' AUTH_CLEAR_ERRORS',
};

export const GetProductsConstants = {
  GET_ALL_PRODUCTS_REQUEST: ' GET_ALL_PRODUCTS_REQUEST',
  GET_ALL_PRODUCTS_SUCCESS: 'GET_ALL_PRODUCTS_SUCCESS',
  GET_ALL_PRODUCTS_FAIL: 'GET_ALL_PRODUCTS_FAIL',

  GET_SINGLE_PRODUCT_REQUEST: ' GET_SINGLE_PRODUCT_REQUEST',
  GET_SINGLE_PRODUCT_SUCCESS: 'GET_SINGLE_PRODUCT_SUCCESS',
  GET_SINGLE_PRODUCT_FAIL: 'GET_SINGLE_PRODUCT_FAIL',

  ADD_SINGLE_PRODUCT_REQUEST: ' ADD_SINGLE_PRODUCT_REQUEST',
  ADD_SINGLE_PRODUCT_SUCCESS: 'ADD_SINGLE_PRODUCT_SUCCESS',
  ADD_SINGLE_PRODUCT_FAIL: 'ADD_SINGLE_PRODUCT_FAIL',


  PRODUCTS_CLEAR_ERRORS: 'PRODUCTS_CLEAR_ERRORS',
};

export const deleteProductsConstants={
  DELETE_SINGLE_PRODUCT_REQUEST: ' DELETE_SINGLE_PRODUCT_REQUEST',
  DELETE_SINGLE_PRODUCT_SUCCESS: 'DELETE_SINGLE_PRODUCT_SUCCESS',
  DELETE_SINGLE_PRODUCT_FAIL: 'DELETE_SINGLE_PRODUCT_FAIL',
}

export const ReviewConstants = {
  PRODUCTS_REVIEW_REQUEST: ' PRODUCTS_REVIEW_REQUEST',
  PRODUCTS_REVIEW_SUCCESS: 'PRODUCTS_ REVIEW_SUCCESS',
  PRODUCTS_REVIEW_FAIL: 'PRODUCTS_REVIEW_FAIL',
};

export const OrdersConstants = {
  ORDERS_REQUEST: ' ORDERS_REQUEST',
  ORDERS_SUCCESS: 'ORDERS_SUCCESS',
  ORDERS_COMPLETED: 'ORDERS_COMPLETED',
  ORDERS_FAIL: 'ORDERS_FAIL',
};
export const CatConstants = {

//for get all category and subcategory
  GET_ALL_CATEGORY_SUBCATEGORY_REQUEST: ' GET_ALL_CATEGORY_SUBCATEGORY_REQUEST',
  GET_ALL_CATEGORY_SUBCATEGORY_SUCCESS: 'GET_ALL_ CATEGORY_SUBCATEGORY_SUCCESS',
  GET_ALL_CATEGORY_SUBCATEGORY_FAIL: 'GET_ALL_CATEGORY_SUBCATEGORY_FAIL',

//for add category and subcategory
  ADD_CATEGORY_REQUEST: ' ADD_CATEGORY_REQUEST',
  ADD_CATEGORY_SUCCESS: ' ADD_CATEGORY_SUCCESS',
  ADD_SUBCATEGORY_REQUEST: ' ADD_SUBCATEGORY_REQUEST',
  ADD_SUBCATEGORY_SUCCESS: ' ADD_SUBCATEGORY_SUCCESS',

//update  category and sub category
UPDATE_CATEGORY_REQUEST:'UPDATE_CATEGORY_REQUEST',
UPDATE_CATEGORY_SUCCESS:'UPDATE_CATEGORY_SUCCESS',
UPDATE_SUBCATEGORY_REQUEST:'UPDATE_SUBCATEGORY_REQUEST',
UPDATE_SUBCATEGORY_SUCCESS:'UPDATE_SUBCATEGORY_SUCCESS',
//FAIL 
CATEGORY_FAIL:'CATEGORY_FAIL'
};

export const InitialDataConstants = {
  INITIAL_DATA_REQUEST: ' INITIAL_DATA_REQUEST',
  INITIAL_DATA_SUCCESS: 'INITIAL_DATA_SUCCESS',
  INITIAL_DATA_FAIL: 'INITIAL_DATA_FAIL',
};

export const CardConstants={
      ADD_TO_CARD:'ADD_TO_CARD'
}

export const CLEAR_ERRORS = 'CLEAR_ERRORS';
